function StatusBtnItem({ icon = "", active = false, onClick = () => {}, tooltip = "" }) {
	return (
		<button
			type="button"
			className={`main_comp_status_action ${active ? "active" : ""}`}
			aria-label={tooltip || "Cambia stato"}
			onClick={(e) => {
				e.stopPropagation();
				onClick(e);
			}}
			data-tooltip-id="tooltip_small_top"
			data-tooltip-offset={10}
			data-tooltip-content={tooltip}
		>
			<span className={`icon_16 default icon_mask icon ${icon}`}></span>
		</button>
	);
}

export default StatusBtnItem;
